import React, { useState, useEffect } from "react"
import {
  Card,
  Row,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  CardHeader,
  CardFooter,
  Alert
} from "reactstrap"
import { withBasicNotify } from "components/notification"
import ReactTable from "react-table"
import _ from "lodash"
import { useMutation } from "@apollo/react-hooks"
import { withRouter } from "react-router"
import Switch from "react-bootstrap-switch"
import { BackButton } from "components/utility"
import { BarLoader } from "components/spinner"
import withModal from "components/modal"
import {
  CREATE_CATEGORY,
  CREATE_SUBCATEGORY,
  UPDATE_CATEGORY,
  UPDATE_SUBCATEGORY
} from "../gql"

import "react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css"

const CategoryFrom = props => {
  const defaultData = {
    name: "",
    isEnable: true
  }
  const [localData, setLocalData] = useState({ ...defaultData })
  const [subcategoryName, setSubcategoryName] = useState("")
  const [subcategoryId, setSubcategoryId] = useState("")
  const [subcategories, setSubcategories] = useState([])
  const [id, setId] = useState(null)
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [updateCategory] = useMutation(UPDATE_CATEGORY)
  const [createCategory] = useMutation(CREATE_CATEGORY)
  const [updateSubcategory] = useMutation(UPDATE_SUBCATEGORY)
  const [createSubcategory] = useMutation(CREATE_SUBCATEGORY)
  const { notify } = props

  useEffect(() => {
    // Props to state
    if (props.data) {
      setId(props.data.id)
      setSubcategories(props.data.subcategories)
      setLocalData({
        ..._.omit(props.data, ["id", "sender", "__typename", "subcategories"])
      })
    }
  }, [props.data])

  const onFieldChange = (key, value) => {
    setLocalData({
      ...localData,
      [key]: value
    })
  }

  const handleMutationSuccess = result => {
    if (result) {
      setLoading(false)
      props.history.goBack()
    }
  }

  const handleMutationError = error => {
    setError(error)
    setLoading(false)
  }

  const updateData = (id, data) => {
    updateCategory({
      variables: {
        id,
        input: {
          ...data
        }
      }
    }).then(
      result => {
        handleMutationSuccess(result)
      },
      error => {
        handleMutationError(error)
      }
    )
  }

  const createData = data => {
    createCategory({
      variables: {
        input: {
          ...data
        }
      }
    }).then(
      result => {
        handleMutationSuccess(result)
      },
      error => {
        handleMutationError(error)
      }
    )
  }

  const createSub = (category, name) => {
    createSubcategory({
      variables: {
        input: {
          category,
          name,
          isEnable: true
        }
      }
    }).then(
      () => {
        setSubcategoryName("")
        props.refetch()
      },
      error => {
        handleMutationError(error)
      }
    )
  }

  const updateSub = (subCategoryId, category, name, isEnable = true) => {
    updateSubcategory({
      variables: {
        id: subCategoryId,
        input: {
          category,
          name,
          isEnable
        }
      }
    }).then(
      () => {
        setSubcategoryId("")
        setSubcategoryName("")
        props.refetch()
        notify.success("儲存成功")
      },
      error => {
        handleMutationError(error)
      }
    )
  }

  const checkRequire = () => {
    return localData.name === ""
  }

  const renderSaveButton = () => {
    return (
      <Button
        color="primary"
        disabled={checkRequire()}
        onClick={e => {
          e.preventDefault()
          setLoading(true)
          if (id) {
            updateData(id, localData)
          } else {
            createData(localData)
          }
        }}
      >
        送出
      </Button>
    )
  }

  const modifySubcategory = (id, categoryName) => {
    setSubcategoryId(id)
    setSubcategoryName(categoryName)
  }

  const renderEditButton = (id, name) => {
    return (
      <div style={{ textAlign: "center" }}>
        <Button
          size="sm"
          round="true"
          icon="true"
          color="inverse"
          onClick={() => {
            modifySubcategory(id, name)
          }}
        >
          <i className="fa fa-edit" />
        </Button>
      </div>
    )
  }

  return (
    <div className="">
      <Card>
        <CardHeader>
          <BackButton left />
        </CardHeader>

        <CardBody className="pb-0">
          <Form
            style={{
              marginLeft: "10px",
              marginRight: "10px"
            }}
          >
            <FormGroup row>
              <Label for="name">類別名稱 *</Label>
              <Input
                type="text"
                name="name"
                id="name"
                placeholder="名稱"
                value={localData.name}
                onChange={e => onFieldChange("name", e.target.value)}
              />
            </FormGroup>
            <FormGroup row className="ml-3">
              <Label check>
                <Input
                  type="checkbox"
                  checked={localData.isEnable}
                  onChange={e => {
                    setLocalData({ ...localData, isEnable: e.target.checked })
                  }}
                />{" "}
                是否啟用
              </Label>
            </FormGroup>
            {id && (
              <FormGroup style={{ marginLeft: "-12px" }}>
                <Card>
                  <CardHeader>子類別維護</CardHeader>
                  <CardBody>
                    <Row className="ml-0">
                      <Input
                        type="text"
                        name="name"
                        id="name"
                        className="mr-2"
                        style={{ width: "200px" }}
                        placeholder="子類別名稱"
                        value={subcategoryName}
                        onChange={e => setSubcategoryName(e.target.value)}
                      />
                      <Button
                        color="info"
                        style={{ marginBottom: "20px" }}
                        onClick={() => {
                          if (subcategoryName === "") {
                            return
                          }

                          if (subcategoryId === "") {
                            createSub(id, subcategoryName)
                          } else {
                            updateSub(subcategoryId, id, subcategoryName)
                          }
                        }}
                      >
                        {subcategoryId ? "更新" : "新增"}
                      </Button>
                      {subcategoryId && (
                        <Button
                          className="ml-2"
                          style={{ marginBottom: "20px" }}
                          onClick={() => {
                            setSubcategoryId("")
                            setSubcategoryName("")
                          }}
                        >
                          X
                        </Button>
                      )}
                    </Row>
                    <ReactTable
                      defaultPageSize={5}
                      getTdProps={() => ({
                        style: {
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center"
                        }
                      })}
                      data={subcategories}
                      columns={[
                        {
                          Header: "id",
                          accessor: "id",
                          show: false
                        },
                        {
                          Header: "編輯",
                          style: { whiteSpace: "unset" },
                          width: 60,
                          Cell: cell => {
                            return renderEditButton(cell.row.id, cell.row.name)
                          }
                        },
                        {
                          Header: "名稱",
                          style: { whiteSpace: "unset" },
                          accessor: "name",
                          Cell: cell => {
                            return (
                              <div style={{ textAlign: "center" }}>
                                {cell.row.name}
                              </div>
                            )
                          }
                        },
                        {
                          Header: "是否啟用",
                          style: { whiteSpace: "unset" },
                          accessor: "isEnable",
                          width: 100,
                          Cell: cell => {
                            return (
                              <div style={{ textAlign: "center" }}>
                                <Switch
                                  defaultValue={cell.row.isEnable}
                                  onText=""
                                  offText=""
                                  onChange={() => {
                                    updateSub(
                                      cell.row.id,
                                      id,
                                      cell.row.name,
                                      !cell.row.isEnable
                                    )
                                  }}
                                />
                              </div>
                            )
                          }
                        }
                        // {
                        //   Header: "刪除",
                        //   width: 60,
                        //   style: { whiteSpace: "unset" },
                        //   Cell: cell => {
                        //     return renderDeleteButton(
                        //       cell.row.id,
                        //       cell.row.name
                        //     )
                        //   }
                        // }
                      ]}
                      showPagination={true}
                    />
                  </CardBody>
                </Card>
              </FormGroup>
            )}
          </Form>
        </CardBody>
        <CardFooter>
          <div>
            {renderSaveButton()}

            <BarLoader loading={loading} />
          </div>
        </CardFooter>
      </Card>
      {!id && (
        <Alert color="warning">
          [提示] 類別需建立成功之後才可以新增子類別。
        </Alert>
      )}
      {error !== "" && <Alert color="danger">錯誤訊息：{`${error}`}</Alert>}
    </div>
  )
}

export default withBasicNotify(withModal(withRouter(CategoryFrom)))
